<template>
  <div class="navbar">
    <div class="navbar-left">
      <hamburger :is-active="sidebar.opened" class="hamburger-btn" @toggleClick="toggleSideBar" />
      <div class="nav-divider" />
      <breadcrumb class="breadcrumb-container" />
    </div>

    <div class="navbar-right">
      <!-- 时钟：小屏隐藏 -->
      <clock class="clock-tag hidden-xs" />
      <div class="nav-divider hidden-xs" />

      <!-- 消息按钮 -->
      <el-popover
        placement="bottom-end"
        width="340"
        trigger="click"
        popper-class="msg-popover"
        @show="fetchMessages"
      >
        <message-panel ref="msgPanel" />
        <el-badge
          slot="reference"
          :value="$store.state.user.unreadmsgcount"
          :hidden="!$store.state.user.unreadmsgcount"
          class="msg-badge"
        >
          <button type="button" class="icon-btn">
            <i class="el-icon-message" />
          </button>
        </el-badge>
      </el-popover>

      <!-- 急单 & 添加客户：小屏折叠进下拉 -->
      <template v-if="hasSellerRole">
        <button type="button" class="icon-btn danger-btn hidden-xs" @click="createUrgentOrder">
          <i class="el-icon-bell" /> <span class="btn-text">创建急单</span>
        </button>
        <button type="button" class="icon-btn primary-btn hidden-xs" @click="newdetailinputerdialog = true">
          <i class="el-icon-user" /> <span class="btn-text">添加客户</span>
        </button>

        <!-- 小屏合并下拉 -->
        <el-dropdown class="hidden-sm-up" trigger="click" @command="handleMobileAction">
          <button type="button" class="icon-btn">
            <i class="el-icon-more" />
          </button>
          <el-dropdown-menu slot="dropdown" class="mobile-action-menu">
            <el-dropdown-item command="urgent">
              <i class="el-icon-bell" style="color:#f56c6c" /> 创建急单
            </el-dropdown-item>
            <el-dropdown-item command="addclient">
              <i class="el-icon-user" style="color:#409eff" /> 添加客户
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </template>

      <pre-order-dialog v-if="hasSellerRole" />

      <div class="nav-divider" />

      <!-- 用户头像 + 名字下拉 -->
      <el-dropdown class="user-dropdown-wrap" trigger="click">
        <div class="user-trigger">
          <avatar :username="name" :size="26" :rounded="true" />
          <span class="user-name hidden-xs">{{ name }}</span>
          <i class="el-icon-caret-bottom caret hidden-xs" />
        </div>
        <el-dropdown-menu slot="dropdown" class="user-dropdown-menu">
          <div class="dropdown-header">
            <avatar :username="name" :size="38" :rounded="true" />
            <div class="dropdown-info">
              <p class="dropdown-name">{{ name }}</p>
              <p class="dropdown-role">{{ $store.state.user.roles[0] }}</p>
            </div>
          </div>
          <router-link to="/">
            <el-dropdown-item><i class="el-icon-house" /> 首页</el-dropdown-item>
          </router-link>
          <template v-if="hasSellerRole">
            <el-dropdown-item class="hidden-sm-up" divided @click.native="createUrgentOrder">
              <i class="el-icon-bell" style="color:#f56c6c" /> 创建急单
            </el-dropdown-item>
            <el-dropdown-item class="hidden-sm-up" @click.native="newdetailinputerdialog = true">
              <i class="el-icon-user" style="color:#409eff" /> 添加客户
            </el-dropdown-item>
          </template>
          <el-dropdown-item divided @click.native="logout">
            <i class="el-icon-switch-button" /> 退出登录
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>

    <el-drawer :visible.sync="drawer" :direction="direction" :before-close="handleClose">
      <tii />
    </el-drawer>

    <el-dialog
      destroy-on-close
      :visible.sync="newdetailinputerdialog"
      :width="dialogWidth"
      @close="newdetailinputerdialog = false"
    >
      <client-detail-inputer :wechatedit="true" :form="newclientform" @success="newclientdetail" />
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import Clock from '@/components/Clock'
import Tii from '@/components/Tii'
import PreOrderDialog from '@/views/order/preorderdialog'
import ClientDetailInputer from '@/views/client/myclients/components/clientdetailinputer/index.vue'
import Avatar from 'vue-avatar'
import MessagePanel from '@/views/user/message/MessagePanel.vue'

export default {
  components: { ClientDetailInputer, Breadcrumb, Hamburger, Clock, Tii, PreOrderDialog, Avatar, MessagePanel },
  data() {
    return {
      drawer: false,
      direction: 'rtl',
      newdetailinputerdialog: false,
      newclientform: {
        ClientWechat: '', ClientType: 'student', ClientSchool: '',
        Tag: '', Remark: '', ClientDetail: '', CourseList: [], Grades: []
      }
    }
  },
  computed: {
    ...mapGetters(['sidebar', 'avatar', 'name']),
    hasSellerRole() {
      const roles = this.$store.state.user.roles
      return roles.includes('seller') || roles.includes('superadmin') || roles.includes('admin')
    },
    dialogWidth() {
      return window.innerWidth < 600 ? '95%' : '520px'
    }
  },
  methods: {
    fetchMessages() {
      this.$refs.msgPanel && this.$refs.msgPanel.getmessagelist()
    },
    newclientdetail() {
      this.newdetailinputerdialog = false
      this.newclientform = {
        ClientWechat: '', ClientType: 'student', ClientSchool: '',
        Tag: '', Remark: '', ClientDetail: '', CourseList: [], Grades: []
      }
    },
    createUrgentOrder() {
      this.$router.push({ path: '/orders/neworder', query: { isurgent: 'true' } })
    },
    handleMobileAction(cmd) {
      if (cmd === 'urgent')    this.createUrgentOrder()
      if (cmd === 'addclient') this.newdetailinputerdialog = true
    },
    handleClose(done) { this.drawer = false; done() },
    toggleSideBar() { this.$store.dispatch('app/toggleSideBar') },
    async logout() {
      await this.$store.dispatch('user/logout')
      this.$router.push(`/login?redirect=${this.$route.fullPath}`)
    }
  }
}
</script>

<style lang="scss" scoped>
/* ── 配色变量（对齐 login）─────────────────────────── */
$primary:           #409eff;
$primary-hover:     #66b1ff;
$primary-light:     #ecf5ff;
$bg-light:          #f5f7fa;
$ink:               #303133;
$ink-soft:          #1a1a1a;
$text-regular:      #606266;
$text-secondary:    #909399;
$text-placeholder:  #c0c4cc;
$border-base:       #dcdfe6;
$border-light:      #e4e7ed;
$error-color:       #f56c6c;
$error-bg:          #fef0f0;
$error-border:      #fde2e2;

/* 响应式断点 */
$breakpoint-sm: 600px;

.hidden-xs    { @media (max-width: $breakpoint-sm) { display: none !important; } }
.hidden-sm-up { @media (min-width: ($breakpoint-sm + 1px)) { display: none !important; } }

.navbar {
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 14px;
  background: #fff;
  border-bottom: 0.5px solid $border-light;
  position: relative;
  box-sizing: border-box;

  @media (max-width: $breakpoint-sm) {
    padding: 0 10px;
    height: 50px;
  }
}

.navbar-left {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
  min-width: 0;
}

.navbar-right {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
}

.nav-divider {
  width: 1px;
  height: 18px;
  background: $border-light;
  margin: 0 4px;
  flex-shrink: 0;
}

.hamburger-btn {
  height: 32px;
  line-height: 32px;
  border-radius: 6px;
  flex-shrink: 0;
  color: $text-regular;
  transition: background 0.2s, color 0.2s;
  &:hover {
    background: $bg-light;
    color: $primary;
  }
}

.breadcrumb-container {
  flex: 1;
  min-width: 0;
  overflow: hidden;
}

/* ── 通用图标按钮 ─────────────────────────────────── */
.icon-btn {
  height: 32px;
  padding: 0 12px;
  border-radius: 6px;
  border: 0.5px solid $border-base;
  background: #fff;
  color: $text-regular;
  font-size: 13px;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  cursor: pointer;
  font-family: inherit;
  transition: all 0.2s;
  white-space: nowrap;

  &:hover {
    background: $bg-light;
    border-color: $primary;
    color: $primary;
  }

  i { font-size: 14px; }

  @media (max-width: $breakpoint-sm) {
    height: 30px;
    padding: 0 10px;
  }
}

/* 主色按钮 */
.primary-btn {
  color: $primary;
  border-color: lighten($primary, 20%);
  background: $primary-light;

  &:hover {
    background: $primary;
    border-color: $primary;
    color: #fff;
    box-shadow: 0 4px 12px rgba(64, 158, 255, 0.25);
  }
}

/* 危险按钮 */
.danger-btn {
  color: $error-color;
  border-color: $error-border;
  background: $error-bg;

  &:hover {
    background: $error-color;
    border-color: $error-color;
    color: #fff;
    box-shadow: 0 4px 12px rgba(245, 108, 108, 0.25);
  }
}

.btn-text {
  @media (max-width: 768px) { display: none; }
}

.msg-badge {
  display: inline-flex;
  align-items: center;

  ::v-deep .el-badge__content {
    background: $error-color;
    border: none;
  }
}

/* ── 用户触发区 ────────────────────────────────────── */
.user-dropdown-wrap { display: inline-flex; align-items: center; }

.user-trigger {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  height: 32px;
  padding: 0 10px 0 4px;
  border-radius: 6px;
  border: 0.5px solid $border-base;
  background: #fff;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: $bg-light;
    border-color: $primary;

    .user-name { color: $primary; }
    .caret     { color: $primary; }
  }

  @media (max-width: $breakpoint-sm) {
    padding: 0 4px;
    border: none;
    background: transparent;
    &:hover { background: $bg-light; }
  }
}

.user-name {
  font-size: 13px;
  font-weight: 500;
  color: $ink;
  max-width: 80px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  transition: color 0.2s;
}

.caret {
  font-size: 10px;
  color: $text-placeholder;
  transition: color 0.2s;
}

/* ── 下拉菜单头部 ──────────────────────────────────── */
.dropdown-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 16px;
  border-bottom: 0.5px solid $border-light;
  margin-bottom: 4px;
  background: linear-gradient(180deg, $bg-light 0%, #fff 100%);
}

.dropdown-info {
  .dropdown-name {
    font-size: 14px;
    font-weight: 500;
    color: $ink-soft;
    margin: 0;
  }
  .dropdown-role {
    font-size: 12px;
    color: $text-secondary;
    margin: 2px 0 0;
    text-transform: capitalize;
  }
}
</style>

<style lang="scss">
/* ── 同步配色变量（非 scoped）──────────────────────── */
$primary:        #409eff;
$primary-light:  #ecf5ff;
$bg-light:       #f5f7fa;
$ink:            #303133;
$text-regular:   #606266;
$border-light:   #e4e7ed;

/* 消息弹窗 */
.msg-popover.el-popover {
  padding: 0 !important;
  border-radius: 8px !important;
  border: 0.5px solid $border-light !important;
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.08) !important;
}

/* 移动端操作菜单 */
.mobile-action-menu.el-dropdown-menu {
  padding: 4px !important;
  border-radius: 8px !important;
  border: 0.5px solid $border-light !important;
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.08) !important;
}
.mobile-action-menu .el-dropdown-menu__item {
  height: 36px;
  font-size: 13px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  gap: 8px;
  color: $text-regular;
  transition: all 0.2s;

  &:hover, &:focus {
    background: $primary-light !important;
    color: $primary !important;
  }
}

/* 用户下拉菜单 */
.user-dropdown-menu.el-dropdown-menu {
  padding: 0 4px 4px !important;
  border-radius: 8px !important;
  border: 0.5px solid $border-light !important;
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.08) !important;
  min-width: 200px;
  max-width: 240px;
  box-sizing: border-box;
  overflow: hidden;
}
.user-dropdown-menu .el-dropdown-menu__item {
  height: 34px;
  line-height: 34px;
  font-size: 13px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 12px !important;
  box-sizing: border-box;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: $text-regular;
  transition: all 0.2s;

  &:hover, &:focus {
    background: $primary-light !important;
    color: $primary !important;
  }
}
.user-dropdown-menu .el-dropdown-menu__item i {
  flex-shrink: 0;
  font-size: 14px;
  width: 16px;
  text-align: center;
}
.user-dropdown-menu .el-dropdown-menu__item--divided {
  margin-top: 4px;
  border-top: 0.5px solid $border-light;

  &::before {
    display: none;
  }
}
</style>